import React from "react";
import logo from "../image/badge.svg"
export default function Navbar(){
    return(
        <div className="navbar">
            <img src={logo} className="nav-logo"/>
            <h4>mytraveljournal</h4>
        </div>
    )
}